import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { CalendarDays, ClipboardPlus, Search, UserPlus } from "lucide-react";
import { toast } from "sonner";

const actions = [
  { to: "/pacientes", label: "Nuevo paciente", icon: UserPlus, testId: "visual-action-new-patient" },
  { to: "/nueva-consulta", label: "Nueva consulta", icon: ClipboardPlus, testId: "visual-action-new-consult" },
  { to: "/agenda", label: "Agenda", icon: CalendarDays, testId: "visual-action-agenda" },
  { to: "/pacientes", label: "Buscar paciente", icon: Search, testId: "visual-action-search" },
];

export default function DashboardQuickActions({ showcaseMode = false }) {
  const handleShowcaseClick = () => {
    toast.info("Disponible en la plataforma autenticada.");
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2" data-testid="dashboard-visual-quick-actions">
      {actions.map((action) => {
        const Icon = action.icon;
        if (showcaseMode) {
          return (
            <Button
              key={action.testId}
              type="button"
              variant="outline"
              className="min-h-12 justify-start border-slate-200 bg-white text-slate-800 hover:bg-sky-50"
              onClick={handleShowcaseClick}
              data-testid={action.testId}
            >
              <Icon className="mr-2 h-4 w-4 text-sky-700" />
              {action.label}
            </Button>
          );
        }
        return (
          <Button
            key={action.testId}
            asChild
            variant="outline"
            className="min-h-12 justify-start border-slate-200 bg-white text-slate-800 hover:bg-sky-50"
          >
            <Link to={action.to} data-testid={action.testId}>
              <Icon className="mr-2 h-4 w-4 text-sky-700" />
              {action.label}
            </Link>
          </Button>
        );
      })}
    </div>
  );
}
